module.exports = __webpack_public_path__ + "assets/CircleTangentPPL.4de134c2d46f52a5f23156b7a5bfca96.gmt";


//////////////////
// WEBPACK FOOTER
// ./src/resources/levels/Gmt/CircleTangentPPL.gmt
// module id = 930
// module chunks = 0